import React, { useContext } from "react";
import MenuSvgIcon from "../../../../../../Svg/MenuSvgIcon";
import constants from "../../../../../../constants";
import AlertContext from "../../../../../../context/AlertContext";
import { isParentLogin } from "../../../../../../util";
import Tooltip from "../../../../../CommonComponents/Tooltip";

export const SOALearningModule = ({ data }) => {
  // console.log("data:", data);

  const { setLpId, navigate } = useContext(AlertContext);

  const studentModuleCompletePercentage = (chapter, chapterCompleted) => {
    if (chapter === 0) {
      return 0;
    }
    return Math.ceil((chapterCompleted / chapter) * 100);
  };

  const onContinue = (lpId, batchName, batchId, batchType, pathName) => {
    localStorage.setItem("batchid", batchId);
    localStorage.setItem("batchType", batchType);
    localStorage.setItem("batchname", batchName);
    setLpId(lpId);
    localStorage.removeItem("mockLp");
    sessionStorage.removeItem("lmpid");
    sessionStorage.setItem("lpId", lpId);
    if (pathName === "dashBoard") {
      navigate("/home");
    } else {
      setTimeout(() => {
        navigate("main/dashboard/learningpath");
      }, 100);
    }
  };

  return (
    <div className="SOALearningModule">
      <div className="SOALearningModuleHeader">
        <div className="SOALearningModuleHeadertopic">
          <Tooltip title={data?.lpName} placement="bottom" >
            <div className="SOALearningModuleHeadertopicname">
              {data?.lpName}
            </div>
          </Tooltip>
          <div className="SOALearningModuleHeadertopicdomain">
            <MenuSvgIcon menuId={constants.MENU_ICON.BATCHES} />
            <p className="SOALearningModuleHeadertopicdomainName">{data?.batchName}</p>
          </div>
        </div>
        {!isParentLogin ? (
          <div className="SOALearningModuleHeaderstatus">
            <button
              className="SOALearningModuleHeaderstatusButton"
              onClick={() => onContinue(data.lpId, data.batchName, data.batchId, data.batchType)}
            >
              Continue
            </button>
          </div>
        ) : null}
      </div>

      <div className="SOALearningModuleStudentInfo">
        <div className="SOALearningModuleChapterInfo">
          <div className="SOALearningModuleChapterInfoData">{`${data?.moduleCount} modules • ${data?.chapterCount} chapters`}</div>
          <div className="SOALearningModuleChapterInfoPercentage">
            {studentModuleCompletePercentage(
              data?.totalCount,
              data?.completedCount
            )}
            %
          </div>
        </div>
        <div className="SOALearningModuleStudentProgressBar">
          <div
            className="SOALearningModuleStudentProgressBarPercentage"
            style={{
              width: `${studentModuleCompletePercentage(
                data?.totalCount,
                data?.completedCount
              )}%`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};
